// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <wt-status-display hovered=\"vm.hovered\" clicked=\"vm.clicked\" statuses=\"vm.statuses\"></wt-status-display> </div>";
// Exports
module.exports = code;